import Image from 'next/image';
import Link from 'next/link';
import React, { useState } from 'react';
import { isEmpty } from '@/utils/common-helpers';

type Props = {
    pageTitle: String;
    onTimeDelivery?: String;
    tailoredBusinessExcellence?: String;
    technologicalExpertiseCenter?: any;
    privacyCommitment?: any;
    specializedTechnicalTeam?: string;
    flexibleHiringModels?: string;
    trustedOutsourcingPartner?: string;
};

const WhyChooseUs: React.FC<Props> = ({
    pageTitle,
    onTimeDelivery,
    tailoredBusinessExcellence,
    technologicalExpertiseCenter,
    privacyCommitment,
    specializedTechnicalTeam,
    flexibleHiringModels,
    trustedOutsourcingPartner,
}) => {
    const [title, setTitle] = useState('vast-talent-pool');

    const selected = (name: string) => {
        switch (title) {
            case name:
                return 'active';
        }
    };

    const scrollTo = (id: string) => {
        setTitle(id);
        const ID = document.getElementById(id);

        ID &&
            ID.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center',
            });
    };

    return (
        <>
            {/* why choose start */}
            <section className="section-py relative" data-aos="fade-up" data-aos-duration="700" data-aos-delay="200">
                <div className="container lg:container mx-auto">
                    <div className="row grid md:grid-cols-12 justify-center">
                        <div className="md:col-span-6 mb-6 mb-md-0">
                            <div className="text-start sticky sticky-list">
                                <p className="fw-700 fs-lg text-primary dark:text-light mb-0">Outsource To Us</p>
                                <h2 className="fw-700 fs-xl mb-[30px]">{pageTitle}</h2>
                                <div className="gap-5 ps-0 fs-mdlg fw-600 flex flex-col" id="list-examples">
                                    <Link
                                        href="javascript:void(0)"
                                        className={`flex items-center gap-2 ${selected('vast-talent-pool')}`}
                                        onClick={() => {
                                            scrollTo('vast-talent-pool');
                                        }}
                                    >
                                        <svg className="ic">
                                            <use xlinkHref="#tabler-icon-square-rounded-check-filled" />
                                        </svg>
                                        On-Time & Budget-Friendly Delivery
                                    </Link>
                                    <Link
                                        href="javascript:void(0)"
                                        className={`flex items-center gap-2 ${selected('technical-expertise')}`}
                                        onClick={() => {
                                            scrollTo('technical-expertise');
                                        }}
                                    >
                                        <svg className="ic">
                                            <use xlinkHref="#tabler-icon-square-rounded-check-filled" />
                                        </svg>
                                        Tailored Business Excellence
                                    </Link>
                                    <Link
                                        href="javascript:void(0)"
                                        className={`flex items-center gap-2 ${selected('affordable-costs')}`}
                                        onClick={() => scrollTo('affordable-costs')}
                                    >
                                        <svg className="ic">
                                            <use xlinkHref="#tabler-icon-square-rounded-check-filled" />
                                        </svg>
                                        Technological Expertise Center
                                    </Link>
                                    <Link
                                        href="javascript:void(0)"
                                        className={`flex items-center gap-2 ${selected('quality-assurance')}`}
                                        onClick={() => scrollTo('quality-assurance')}
                                    >
                                        <svg className="ic">
                                            <use xlinkHref="#tabler-icon-square-rounded-check-filled" />
                                        </svg>
                                        Privacy Commitment
                                    </Link>
                                    <Link
                                        href="javascript:void(0)"
                                        className={`flex items-center gap-2 ${selected('timely-solutions')}`}
                                        onClick={() => scrollTo('timely-solutions')}
                                    >
                                        <svg className="ic">
                                            <use xlinkHref="#tabler-icon-square-rounded-check-filled" />
                                        </svg>
                                        Specialized Technical Team
                                    </Link>
                                    <Link
                                        href="javascript:void(0)"
                                        className={`flex items-center gap-2 ${selected('support-maintenance')}`}
                                        onClick={() => scrollTo('support-maintenance')}
                                    >
                                        <svg className="ic">
                                            <use xlinkHref="#tabler-icon-square-rounded-check-filled" />
                                        </svg>
                                        Flexible Hiring Models
                                    </Link>
                                    <Link
                                        href="javascript:void(0)"
                                        className={`flex items-center gap-2 ${selected('trusted-partner')}`}
                                        onClick={() => scrollTo('trusted-partner')}
                                    >
                                        <svg className="ic">
                                            <use xlinkHref="#tabler-icon-square-rounded-check-filled" />
                                        </svg>
                                        Trusted Outsourcing Partner
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="md:col-span-6">
                            <ul className="flex flex-col gap-10 ps-0 sticky-content">
                                <li className={selected('vast-talent-pool')} id="vast-talent-pool">
                                    <div className="card dev-service-card h-full">
                                        <div className="card-body mb-0">
                                            <Image
                                                src="/img/technology/ic-portaldevelopment.svg"
                                                className="img-fluid mb-4 development-img"
                                                alt="Vast Talent Pool"
                                                title="Vast Talent Pool"
                                                width={64}
                                                height={64}
                                            />
                                            <h3 className="card-title fs-lg fw-700 mb-4 mt-0">
                                                On-Time & Budget-Friendly Delivery
                                            </h3>
                                            <p className="card-text fw-400 fs-md text-secodary">
                                                {isEmpty(onTimeDelivery)
                                                    ? "At Moweb, we prioritize on-time delivery, understanding that it's crucial to your success. We meticulously plan and execute projects, ensuring they align with your timelines and budgets. With us, you can trust that your project will be delivered promptly, without compromising quality or budget."
                                                    : onTimeDelivery}
                                            </p>
                                        </div>
                                    </div>
                                </li>
                                <li id="technical-expertise" className={selected('technical-expertise')}>
                                    <div className="card dev-service-card h-full">
                                        <div className="card-body mb-0">
                                            <Image
                                                src="/img/technology/ic-consulting-services.svg"
                                                className="img-fluid mb-4 development-img"
                                                alt="Technical Expertise"
                                                title="Technical Expertise"
                                                width={64}
                                                height={64}
                                            />
                                            <h3 className="card-title fs-lg fw-700 mb-4 mt-0">Tailored Business Excellence</h3>
                                            <p className="card-text fw-400 fs-md text-secodary">
                                                {isEmpty(tailoredBusinessExcellence)
                                                    ? 'We believe in tailoring our business solutions to meet your unique needs. Excellence is our standard, and we ensure that every solution we provide aligns seamlessly with your objectives. Our commitment to excellence means you can trust us to deliver tailored solutions that empower your business to thrive.'
                                                    : tailoredBusinessExcellence}
                                            </p>
                                        </div>
                                    </div>
                                </li>
                                <li id="affordable-costs" className={selected('affordable-costs')}>
                                    <div className="card dev-service-card h-full">
                                        <div className="card-body mb-0">
                                            <Image
                                                src="/img/technology/ic-development.svg"
                                                className="img-fluid mb-4 development-img"
                                                alt="Affordable Costs"
                                                title="Affordable Costs"
                                                width={64}
                                                height={64}
                                            />
                                            <h3 className="card-title fs-lg fw-700 mb-4 mt-0">Technological Expertise Center</h3>
                                            <p className="card-text fw-400 fs-md text-secondary">
                                                {isEmpty(technologicalExpertiseCenter)
                                                    ? 'Our vast pool of tech expertise is at the core of our offerings. By partnering with us, you have access to the latest technical knowledge and a well-equipped infrastructure. We support you by providing expert guidance and bespoke solutions to address your business challenges and drive growth.'
                                                    : technologicalExpertiseCenter}{' '}
                                            </p>
                                        </div>
                                    </div>
                                </li>
                                <li id="quality-assurance" className={selected('quality-assurance')}>
                                    <div className="card dev-service-card h-full">
                                        <div className="card-body mb-0">
                                            <Image
                                                src="/img/technology/ic-migration-upgradation.svg"
                                                className="img-fluid mb-4 development-img"
                                                alt="Quality Assurance"
                                                title="Quality Assurance"
                                                width={64}
                                                height={64}
                                            />
                                            <h3 className="card-title fs-lg fw-700 mb-4 mt-0">Privacy Commitment</h3>
                                            <p className="card-text fw-400 fs-md text-secodary">
                                                {isEmpty(privacyCommitment)
                                                    ? 'Your privacy and confidentiality are of the utmost importance to us. We have stringent measures in place to safeguard your data and sensitive information. With our commitment to privacy, you can have peace of mind, knowing that your confidential information is in secure hands.'
                                                    : privacyCommitment}
                                            </p>
                                        </div>
                                    </div>
                                </li>
                                <li id="timely-solutions" className={selected('timely-solutions')}>
                                    <div className="card dev-service-card h-full">
                                        <div className="card-body mb-0">
                                            <Image
                                                src="/img/technology/ic-spas.svg"
                                                className="img-fluid mb-4 development-img"
                                                alt="Timely Solutions"
                                                title="Timely Solutions"
                                                width={64}
                                                height={64}
                                            />
                                            <h3 className="card-title fs-lg fw-700 mb-4 mt-0">Specialized Technical Team</h3>
                                            <p className="card-text fw-400 fs-md text-secodary">
                                                {isEmpty(specializedTechnicalTeam)
                                                    ? "We provide skilled technical experts for your project's success. Our team includes engineers, designers, developers, quality analysts, business analysts, business development managers, and project managers tailored to your hiring needs."
                                                    : specializedTechnicalTeam}
                                            </p>
                                        </div>
                                    </div>
                                </li>
                                <li id="support-maintenance" className={selected('support-maintenance')}>
                                    <div className="card dev-service-card h-full">
                                        <div className="card-body mb-0">
                                            <Image
                                                src="/img/technology/ic-webapp.svg"
                                                className="img-fluid mb-4 development-img"
                                                alt="webapp"
                                                title="webapp"
                                                width={64}
                                                height={64}
                                            />
                                            <h3 className="card-title fs-lg fw-700 mb-4 mt-0">Flexible Hiring Models</h3>
                                            <p className="card-text fw-400 fs-md text-secodary">
                                                {isEmpty(flexibleHiringModels)
                                                    ? 'Moweb offers flexible engagement models tailored to your unique project requirements. Choose from hourly assistance, committed teams, or fixed-price agreements to customize your needs. Our adaptable options ensure a personalized experience from start to finish.'
                                                    : flexibleHiringModels}
                                            </p>
                                        </div>
                                    </div>
                                </li>
                                <li id="trusted-partner" className={selected('trusted-partner')}>
                                    <div className="card dev-service-card h-full">
                                        <div className="card-body mb-0">
                                            <Image
                                                src="/img/technology/ic-trusted-partners.svg"
                                                className="img-fluid mb-4 development-img"
                                                alt="webapp"
                                                title="webapp"
                                                width={64}
                                                height={64}
                                            />
                                            <h3 className="card-title fs-lg fw-700 mb-4 mt-0">Trusted Outsourcing Partner</h3>
                                            <p className="card-text fw-400 fs-md text-secodary">
                                                {isEmpty(trustedOutsourcingPartner)
                                                    ? 'We prioritize your success as our top goal for web and mobile development outsourcing services. Our team works closely with you to understand your goals and challenges to deliver result-oriented and client-centric business solutions. Choose us as your partner to experience the benefits of committed outsourcing.'
                                                    : trustedOutsourcingPartner}
                                            </p>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            {/* why choose end */}
        </>
    );
};

export default WhyChooseUs;
